import TickerResultCard from "../results/TickerResultCard";
import { toArray } from "../sports/tickerSportUtils";

/** Renderiza exclusivamente el arreglo `upcoming` con reglas independientes. */
export default function TickerUpcomingContent({ upcoming, league, sportCode }) {
  return toArray(upcoming).filter(Boolean).map((event, index) => (
    <TickerResultCard
      key={`upcoming-${event.id || event.opta_event_url || index}`}
      result={{ ...event, class: event.class || "clarosports-next-game" }}
      league={league}
      sportCode={sportCode}
    />
 ));
}